import * as React from "react"
import * as SwitchPrimitive from "@radix-ui/react-switch"

import { cn } from "@/lib/utils"

function Switch({
  className,
  ...props
}: React.ComponentProps<typeof SwitchPrimitive.Root>) {
  return (
    <SwitchPrimitive.Root
      data-slot="switch"
      className={cn(
        "border-ud-orange dark:border-ud-dm-orange",
        "data-[state=checked]:bg-ud-orange-50 dark:data-[state=checked]:bg-ud-dm-orange-50",
        "focus-visible:border-ud-orange focus-visible:ring-ud-orange-50",
        "peer inline-flex h-[1.15rem] w-8 shrink-0 items-center rounded-full border shadow-xs transition-all outline-none focus-visible:ring-[3px] disabled:cursor-not-allowed disabled:opacity-50",
        className
      )}
      {...props}
    >
      <SwitchPrimitive.Thumb
        data-slot="switch-thumb"
        className={cn(
          "pointer-events-none block size-4 rounded-full ring-0 transition-transform data-[state=checked]:translate-x-[calc(100%-2px)] data-[state=unchecked]:translate-x-0",
          "dark:data-[state=unchecked]:bg-ud-dm-orange-50 dark:data-[state=checked]:bg-ud-dm-orange",
          "data-[state=unchecked]:bg-ud-orange-50 data-[state=checked]:bg-ud-orange",
        )}
      />
    </SwitchPrimitive.Root>
  )
}

export { Switch }
